import React from 'react';
import {StationThumbnail} from "../../components/Station/Station";
import {Player} from "../../components";
import "./NowPlaying.css";

function NowPlaying({currentStation, isPlaying, setIsPlaying, nowPlayingStatus, nowPlayingTrack}) {
	return (
		<section className="player-panel">
			<div className="panel-header">
				<div>
					<h2 className="panel-title">Now playing</h2>
				</div>
			</div>

			<div className="player-panel-body">
				<StationInfo currentStation={currentStation} nowPlayingStatus={nowPlayingStatus} isPlaying={isPlaying}
				             setIsPlaying={setIsPlaying} nowPlayingTrack={nowPlayingTrack}/>
			</div>
		</section>
	);
}

function StationInfo({currentStation, isPlaying, setIsPlaying, nowPlayingStatus, nowPlayingTrack}) {
	if (currentStation) {
		return (
			<>
				<div className="now-playing-card">
					<StationThumbnail station={currentStation} context="player"/>
					<div className="now-playing-info">
						<div className="now-playing-header">
							<h3 className="now-playing-title">{currentStation.name}</h3>
							{isPlaying && (<span className="live-pill">Live</span>)}
						</div>
						<p className="now-playing-description">
							{nowPlayingStatus === "ready" ? nowPlayingTrack : ""}
						</p>
					</div>
				</div>
				<Player currentStation={currentStation} setIsPlaying={setIsPlaying}/>
			</>
		)
	}

	return (
		<p className="empty-message">
			Choose a station to start listening.
		</p>
	)
}

export default NowPlaying;
